import _ from 'lodash';
import React, {Component} from 'react';
import {Field, reduxForm, getFormValues} from 'redux-form';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {withFirebase} from 'react-redux-firebase';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
// core components
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import loginPageStyle from 'assets/jss/material-kit-react/views/loginPage.jsx';
import streetart1080 from "assets/img/background/street-art1080.jpg"
import {LOGIN_FIELDS} from './formFields';
// import asyncValidate from './asyncValidate';
import SocialMediaLogin from "components/SocialLogins/SocialLogins.jsx"
import {logoutUser, loginFirebaseUser, resetErrorAfterPrompt, sendResetPwEmail} from '../actions';
import LoadingSpinner from 'utils/LoadingSpinner/';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
    };
  }

  componentDidMount() {
    this.props.resetErrorAfterPrompt();
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      500
    );
    //TODO remove this later, need to setup redirect if already logged in?
    this.props.logoutUser();
  }

  clickPwReset() {
    const {values} = this.props;
    // console.log('vals', values);
    if (!values || _.isEmpty(values.email)) {
      alert("Please type your email, so we can send you a link to reset your password!");
    } else {
      this.props.sendResetPwEmail(values.email);
    }
  }

  async onFormSubmit(values) {
    const {email, password} = values;
    const {loginFirebaseUser, history} = this.props;
    loginFirebaseUser(email.trim(), password, history);
  }

  renderTextField(field) {
    return (
      <TextField
        id={field.name}
        label={field.label}
        fullWidth
        required
        margin='normal' // 'none' | 'dense' | 'normal'
        InputProps={{
          type: field.inputType,
          endAdornment: (
            <InputAdornment position="end">
              <field.iconType className={field.iconClassName} />
            </InputAdornment>
          )
        }}
        {...field.input}
        {...field.custom}
      />
    );
  }

  renderLoginForm() {
    const {classes, handleSubmit, reset, profile, resetErrorAfterPrompt} = this.props;

    if (profile.loading) {
      return <LoadingSpinner />;
    } else if (profile.error) {
      alert(profile.error);
      resetErrorAfterPrompt();
    }

    return (
      <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))} className={classes.form}>
        <p className={classes.divider}>New to pollpals? <a href="/user/signup">Sign up</a></p>
        <br />
        <p className={classes.signupHelper}>Log in to track polls you answer, create and share with pals.</p>
        <p className={classes.signupHelper}>Follow pals to send messages and see your total number of matching answers.</p>
        <SocialMediaLogin />
        <CardBody>
          {_.map(LOGIN_FIELDS, (field, fname) => {
            return (
              <Field
                label={field.label}
                name={fname}
                key={fname}
                inputType={field.inputType}
                iconType={field.iconType}
                iconClassName={classes.inputIconsColor}
                component={this.renderTextField}
              />
            );
          })}
          <p className={classes.forgotPw}><a onClick={()=>this.clickPwReset()} href="/user/login">Forgot pw?</a></p>
        </CardBody>
        <CardFooter className={classes.cardFooter}>
          <Button fullWidth style={{marginRight: 10}} color="primary" size="lg" type="submit">
            Login
          </Button>
          <p>{"\n"}</p>
          <Button fullWidth simple color="primary" size="lg" onClick={reset}>
            Clear
          </Button>
        </CardFooter>
      </form>
    );
  }

  render() {
    const {classes, ...rest} = this.props;

    return (
      <div>
        <Header
          color="white"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{height: 200, color: "white"}}
          {...rest}
        />
        <div
          className={classes.pageHeader}
          style={{
            backgroundImage: "url(" + streetart1080 + ")",
            backgroundSize: "cover",
            backgroundPosition: "top center"
          }}
        >
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} md={8} lg={6}>
                <Card className={classes[this.state.cardAnimaton]}>
                  <CardHeader color="primary" className={classes.cardHeader}>
                    <h3>Welcome Back!</h3>
                  </CardHeader>
                  {this.renderLoginForm()}
                </Card>
              </GridItem>
            </GridContainer>
          </div>
          <Footer whiteFont />
        </div>
      </div>
    );
  }
}

const pageWithStylesAndFirebase = withStyles(loginPageStyle)(withFirebase(LoginPage));

function mapStateToProps(state) {
  return {
    values: getFormValues('LoginForm')(state),
    profile: state.profile,
  };
}

export default reduxForm({
  form: 'LoginForm',
})(
  withRouter(connect(mapStateToProps, {
    logoutUser, loginFirebaseUser, resetErrorAfterPrompt, sendResetPwEmail
  })(pageWithStylesAndFirebase))
);



// WEBPACK FOOTER //
// ./src/views/LoginPage.js